import { z } from "zod";

export const weightSchema = z
	.string()
	.regex(/^\d+$/, "Must be a non-negative whole number")
	.transform((val) => Number.parseInt(val, 10))
	.refine((val) => Number.isInteger(val) && val >= 0, {
		message: "Value must be a non-negative integer",
	});
